import clsx from 'clsx'
import React from 'react'
import { chaseHeadingData } from './chaseListComponents/chaseListData'
import SkeltonTableRow from './skelton/SkeltonTableRow'
import NoItem from './NoItem'

/** House style for table headers — sticky-safe surface, small uppercase label, hairline rule. */
export const tableHeaderClass =
    "bg-surface uppercase text-light-gray font-semibold text-[10px] tracking-[0.08em] py-3 border-b border-edge first:pl-1"

interface ITableWrapper {
    children: React.ReactNode
    headingData: typeof chaseHeadingData,
    additionalClasses?: string
    headerClass?: string
    isLoading?: boolean
    totalCount?: number
}

const TableWrapper: React.FC<ITableWrapper> = ({ children, headingData, additionalClasses, headerClass, isLoading, totalCount }) => {
    return (
        <>
            <div className="smallTablet:overflow-x-auto smallTablet:-mx-1 smallTablet:px-1">
            <table
                className={clsx("table-auto h-max w-full text-left smallTablet:min-w-[720px]", additionalClasses)}
            >
                <thead>
                    <tr className={clsx("font-medium", !headerClass && "border-b border-edge-faint")}>
                        {headingData.map((data, index) => (
                            <th
                                key={index}
                                colSpan={data.colSpan}
                                className={clsx(
                                    headerClass ?? "uppercase text-light-gray font-medium text-[10px] py-2 tracking-wider",
                                    data.align
                                )}
                            >
                                {data.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? <SkeltonTableRow /> : children}
                </tbody>
            </table>
            </div>
            {(totalCount === 0 && !isLoading) && <NoItem />}
        </>
    )
}

export default TableWrapper
